'use strict';

import angular from 'angular';

function GrpFeeResource($resource) {
  return $resource('/api/groups/:groupId/groupfees/:id/:controller', {
    id: '@id'
  }, {
    getDefinedFor: {
      method: 'GET',
      isArray: true
    },
    create: {
      method: 'POST',
      url: '/api/groups/:groupId/groupfees'
    },
    update: { method: 'PUT' }
  });
}

GrpFeeResource.$inject = ['$resource'];

export default angular.module('georgeApp.grpFeeSvc', [])
  .factory('GrpFeeSvc', GrpFeeResource)
  .name;
